import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-175">
      <div className="max-w-3xl mx-auto text-center" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-brand-50 border-2 border-brand-200 rounded-3xl p-8 md:p-12 relative overflow-hidden" data-id="element-177">
          <div className="absolute top-0 left-0 w-full h-2 bg-brand-500" data-id="element-178" />

          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-brand-100 mb-6" data-id="element-179">
            <ShieldCheck className="w-10 h-10 text-brand-600" data-id="element-180" />
          </div>

          <h2 className="text-2xl md:text-3xl font-black text-stone-900 mb-6" data-id="element-181">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <div className="space-y-4 text-lg text-stone-700 font-medium mb-8" data-id="element-182">
            <p data-id="element-183">Abrís los tomos. Los usás en el aula.</p>
            <p data-id="element-184">
              Si en 7 días no es lo que esperabas: devolución del 100% sin
              formularios, sin drama, sin esperas.
            </p>
            <p data-id="element-185">
              Escribís a{' '}
              <a href="mailto:reconectacontigohoy506@gmail.com" className="text-brand-600 hover:underline" data-id="element-186">
                reconectacontigohoy506@gmail.com
              </a>{' '}
              y listo.
            </p>
          </div>

          <div className="inline-block bg-white px-4 py-2 rounded-lg border border-stone-200 text-sm font-bold text-stone-500" data-id="element-187">
            Tasa de devoluciones: menos del 1%.
          </div>
        </motion.div>
      </div>
    </section>;
}